<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Testimonies</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">

            <testimonies-list :globalEnpoint="globalEnpoint" :searchEndpoint="searchEndpoint" :searchEnabled="searchEnabled" :additionalQueryParam="additionalQueryParam"/>
            
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Testimonies',
  data () {
    return {
      globalEnpoint: '/testimonies',
      searchEndpoint: '/testimonies/search',
      additionalQueryParam: '',
      searchEnabled: true
    }
  }
}

</script>



// WEBPACK FOOTER //
// Testimonies.vue?f1e37af0